import { Component, Inject, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GradeStatement, GradeStatementOption } from '../../shared/interface/grade-statement.interface';
import { Student, StudentGradeStatement } from '../../shared/interface/roster.interface';
import { GenericFormGroupComponent } from '../../forms/generic-form-group.component';

@Component({
    selector: 'app-roster-grade-statement',
    templateUrl: './grade-statement.component.html',
    styleUrls: ['./grade-statement.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class GradeStatementComponent extends GenericFormGroupComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<GradeStatementComponent>,
        @Inject(MAT_DIALOG_DATA) public data: StudentGradeStatement,
        protected renderer2: Renderer2
    ) {
        super(renderer2);
    }
    showSelect: boolean;
    gradeStatement: GradeStatement;
    gradeStatementOptions: GradeStatementOption[];
    student: Student;

    ngOnInit(): void {
        this.gradeStatement = this.data.gradeStatement;

        this.gradeStatementOptions = this.gradeStatement.gradeStatementText.gradeStatementOption.sort(
            function compareFn(a: GradeStatementOption, b: GradeStatementOption) {
                return a.sortOrder - b.sortOrder;
            }
        );

        this.student = this.data.student; // get student data

        // find which statement to dispaly
        if (
            this.gradeStatement.gradeStatementText.gradeStatementOption.find(
                (item: GradeStatementOption) => item.displayAsOption === true
            )
        ) {
            this.showSelect = true;
        } else {
            // not show selected. default id response
            //note: this is for GD grading which does not have a drop down.
            this.showSelect = false;
            this.data.student.gradeResponse.gradeStatementOptionId =
                this.gradeStatement.gradeStatementText.gradeStatementOption[0].id;
        }
    }

    onCancelClick(): void {
        this.data.student.gradeResponse.agree = false;
        this.data.student.gradeResponse.gradeStatementOptionId = -1;
        this.dialogRef.close();
    }

    onSubmitClick(): void {
        this.dialogRef.close();
    }

    canSubmit(): boolean {
        //has grading select option must select

        if (
            this.gradeStatement.gradeStatementText.gradeStatementOption &&
            this.data.student.gradeResponse.gradeStatementOptionId > 0 &&
            this.data.student.gradeResponse.agree
        ) {
            return true;
        } else {
            if (!this.gradeStatement.gradeStatementText.gradeStatementOption && this.data.student.gradeResponse.agree) {
                return true;
            }
        }

        return false;
    }
}
